import React from 'react';
import { Box } from '@mui/material';
import SystemUsersTab from './SystemUsersTab';

export default function SystemUsersPage() {
  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <SystemUsersTab />
    </Box>
  );
}
